import createIcon from '../../createIcon';

/**
 * @component @name SettingsCell
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNyAyNEg5VjIySDdWMjRaTTExIDI0SDEzVjIySDExVjI0Wk0xNSAyNEgxN1YyMkgxNVYyNFpNMTYgMC4wMUw4IDBDNi45IDAgNiAwLjkgNiAyVjE4QzYgMTkuMSA2LjkgMjAgOCAyMEgxNkMxNy4xIDIwIDE4IDE5LjEgMTggMThWMkMxOCAwLjkgMTcuMSAwLjAxIDE2IDAuMDFaTTE2IDE2SDhWNEgxNlYxNloiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SettingsCell = createIcon('SettingsCell', [
  [
    'path',
    {
      d: 'M7 24H9V22H7V24ZM11 24H13V22H11V24ZM15 24H17V22H15V24ZM16 0.01L8 0C6.9 0 6 0.9 6 2V18C6 19.1 6.9 20 8 20H16C17.1 20 18 19.1 18 18V2C18 0.9 17.1 0.01 16 0.01ZM16 16H8V4H16V16Z',
      key: '7v7gw3',
    },
  ],
]);

export default SettingsCell;
